import React, { useEffect, useState, useRef } from 'react';
import styles from './YotpoReviews.module.scss';
import { getProducts } from '../../../../commons/utils/productsHelper';
import { DotsCircular } from '../../../global/backdrop/spinner';
import { config, productsKeyConstants } from '../../../../config';
import { RatingWithCount, CountryDropdown } from '../../../../commons/hoc';
import { Typography } from '@mui/material';

const YotpoReviews = ({
  product = productsKeyConstants.RF_QUICKSTART,
  showDropdown = false,
  ...rest
}) => {
  const products = getProducts();
  const [selectedProduct, setSelectedProduct] = useState(product);
  const [enableLoader, setEnableLoader] = useState(true);
  const reviewDiv = useRef(null);

  useEffect(() => {
    try {
      if (
        typeof yotpoWidgetsContainer != 'undefined' &&
        yotpoWidgetsContainer
      ) {
        setTimeout(() => {
          yotpoWidgetsContainer.initWidgets();
        }, [1000]);
      } else {
        yotpoWidgetsContainer.initWidgets();
        setEnableLoader(true);
      }
    } catch (er) {
      console.log('er', er);
    }
  }, [selectedProduct]);

  useEffect(() => {
    const handleDOMChanges = (mutations) => {
      mutations.forEach(function (mutation) {
        var newNodes = mutation.addedNodes; // DOM NodeList
        if (newNodes !== null && newNodes.length != 0) {
          if (enableLoader) setEnableLoader(false);
        }
      });
    };

    const observerConfig = {
      attributes: true,
      childList: true,
      characterData: true,
    };

    let yotpoDiv = document.getElementById('yotpo-review-div');

    const domObserver = new MutationObserver(handleDOMChanges);
    domObserver.observe(yotpoDiv, observerConfig);

    return () => {
      domObserver.disconnect();
    };
  }, [selectedProduct]);

  const mappedProducts = {
    [productsKeyConstants.RF_RELIEF_FACTOR_QS]: {
      name: 'Relief Factor',
      key: productsKeyConstants.RF_RELIEF_FACTOR_QS,
      url: `${config.SiteURL}products/relief-factor`,
    },
    [productsKeyConstants.RF_Z_FACTOR]: {
      name: 'Z Factor',
      key: productsKeyConstants.RF_Z_FACTOR,
      url: `${config.SiteURL}products/z-factor`,
    },
    [productsKeyConstants.RF_GO_FACTOR]: {
      name: 'Go Factor',
      key: productsKeyConstants.RF_GO_FACTOR,
      url: `${config.SiteURL}products/go-factor`,
    },
    [productsKeyConstants.RF_ZEN_FACTOR]: {
      name: 'Zen Factor',
      key: productsKeyConstants.RF_ZEN_FACTOR,
      url: `${config.SiteURL}products/zen-factor`,
    },
  };

  return (
    <div className={styles.bottomFrame}>
      <div className={styles.ratingWithCountContainer}>
        <RatingWithCount
          displayScore={true}
          fetchFromYotpo={true}
          size="medium"
          product={selectedProduct}
        />
      </div>
      <div>
        <Typography variant="h1" align="center" color={'primary.main'}>
          {`Latest ${mappedProducts[selectedProduct]?.name} Reviews`}
        </Typography>
      </div>
      {showDropdown && (
        <div className={styles.productDropdown}>
          <CountryDropdown
            options={Object.values(mappedProducts)}
            name="ReviewProduct"
            tkey="name"
            pkey="key"
            id="choose-review-product"
            addNewOption={false}
            selectLabel={false}
            label="Reviews for:"
            onChange={(e) => {
              setSelectedProduct(e.target.value);
              reviewDiv.current.className = 'yotpo yotpo-main-widget';
              setEnableLoader(true);
            }}
          />
        </div>
      )}
      {enableLoader && (
        <div className={styles.spinnerContainer}>
          <DotsCircular contrast={true} />
        </div>
      )}
      <div
        ref={reviewDiv}
        id="yotpo-review-div"
        className={`yotpo yotpo-main-widget`}
        data-product-id={products[selectedProduct].quoteParams?.productId}
        data-price={products[selectedProduct]?.initialPrice}
        data-currency="USD"
        data-name={products[selectedProduct]?.productName}
        data-url={mappedProducts[selectedProduct]?.url}
        // data-image-url="https://m2beta-frontend.relieffactor.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Frf_quickstart_large.133bd35a.png&w=1920&q=75"
        data-autoload="false"
        data-cache-duration="3600"
      ></div>
      {/* <iframe
         style={{ height: iFrameHeight }}
         id="yotpoIFrame"
         src={`/yotpo.html?data-product-id=${products[product].quoteParams?.productId}&data-url=${config.SiteURL}products/quickstart`}
         frameBorder="0"
         className={styles.iframeContent}
       /> */}
    </div>
  );
};

export default YotpoReviews;
